import MarkerPin from '@/assets/img/pin.png';
import { Map } from '@/components/Map';
import { StructureType } from '@/lib/model';
import * as React from 'react';
import { Layer, Marker, Source } from 'react-map-gl';

export interface LocalMapProps {
  coordinates?: number[];
  sourceId: string;
  sourceUrl: string;
  layerId: string;
  sourceLayer: string;
  featureId: number;
  fillColor: string;
  structureType: StructureType;
}

export const LocalMap: React.FC<LocalMapProps> = ({
  coordinates,
  sourceId,
  sourceUrl,
  layerId,
  sourceLayer,
  featureId,
  fillColor,
  structureType,
}) => {
  if (!coordinates) {
    return null;
  }

  return (
    <Map
      initialViewState={{
        longitude: coordinates[0],
        latitude: coordinates[1],
        zoom: 8,
      }}
      cooperativeGestures={true}
    >
      <Source id={sourceId} type="vector" url={sourceUrl}>
        <Layer
          id={layerId}
          source-layer={sourceLayer}
          type="fill"
          filter={['==', layerId, featureId]}
          paint={{
            'fill-color': fillColor,
            'fill-opacity': 0.5,
            'fill-outline-color': '#000',
          }}
          key={structureType}
        />
      </Source>
      <Marker
        longitude={coordinates[0]}
        latitude={coordinates[1]}
        anchor="bottom"
      >
        <img src={MarkerPin} />
      </Marker>
    </Map>
  );
};
